import { motion } from "framer-motion";
import { PROFILE } from "../data/projects";

export const About = () => (
  <section id="about" data-testid="about-section" className="bg-[#f8f9fa] py-24">
    <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-14 px-6 lg:grid-cols-2">
      <motion.div
        initial={{ opacity: 0, x: -40 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="relative"
      >
        <div className="dots-pattern absolute -bottom-8 -right-8 hidden h-40 w-40 md:block" />
        <div className="absolute -left-3 top-10 hidden h-56 w-1.5 bg-accent md:block" />
        <img
          data-testid="about-portrait"
          src={PROFILE.portrait}
          alt={PROFILE.name}
          loading="lazy"
          className="relative w-full object-cover shadow-xl"
        />
      </motion.div>

      <motion.div
        initial={{ opacity: 0, x: 40 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
      >
        <span className="mb-3 block text-xs font-medium uppercase tracking-[0.3em] text-accent">About Me</span>
        <h2 className="text-3xl font-semibold tracking-tight text-[#212529] md:text-4xl">
          We can make it together
        </h2>
        <p className="mt-6 leading-relaxed text-[#6c757d]">
          I'm Harshith Holla — a visual designer and creative professional with 5+ years of experience
          developing visual assets across brand identity, marketing campaigns, digital content, social media,
          print and screen-based media.
        </p>
        <p className="mt-4 leading-relaxed text-[#6c757d]">
          I take work from initial concepts through to polished delivery, with a detail-focused approach to
          composition, consistency and audience engagement — and I'm always exploring new design tools and
          emerging creative technology.
        </p>
        <div className="mt-6 grid grid-cols-1 gap-4 text-sm sm:grid-cols-2">
          <div>
            <span className="block text-xs uppercase tracking-widest text-[#6c757d]">Location</span>
            <span className="font-medium text-[#212529]">{PROFILE.location}</span>
          </div>
          <div>
            <span className="block text-xs uppercase tracking-widest text-[#6c757d]">Status</span>
            <span className="font-medium text-[#212529]">Full-Time — Full UK Work Rights</span>
          </div>
          <div>
            <span className="block text-xs uppercase tracking-widest text-[#6c757d]">Languages</span>
            <span className="font-medium text-[#212529]">English, Hindi, Kannada</span>
          </div>
          <div>
            <span className="block text-xs uppercase tracking-widest text-[#6c757d]">Relocation</span>
            <span className="font-medium text-[#212529]">Willing to Relocate</span>
          </div>
        </div>
        <a
          data-testid="about-cv-btn"
          href={PROFILE.resume}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-8 inline-block rounded-full border border-[#212529]/30 px-8 py-3 text-sm font-medium uppercase tracking-wider text-[#212529] transition-all duration-400 hover:border-accent hover:bg-accent hover:text-white"
        >
          View My Resume
        </a>
      </motion.div>
    </div>
  </section>
);
